import { combineReducers } from 'redux';
import authReducer from './auth/reducer';
import {
  companies as companiesReducer,
  partners as partnersReducer,
  properties as propertiesReducer,
} from './companies/reducer';
import { users as usersReducer, user as userReducer } from './users/reducer';
import { invitations as invitationsReducer } from './people/reducer';

export default combineReducers({
  auth: authReducer,
  companies: companiesReducer,
  invitations: invitationsReducer,
  partners: partnersReducer,
  properties: propertiesReducer,
  users: usersReducer,
  user: userReducer,
});
